import { State } from 'src/global/store';

export const getShareId = (state: State) => state.virality.shareId;

export const getIsNewSignUp = (state: State) => state.virality.isNewSignUp;
